// Generated by CoffeeScript 1.11.1
(function() {
  var Resource, Util;

  Util = require('./util');

  module.exports = Resource = (function() {
    Resource.Section = require('./resource_section');

    function Resource(file) {
      this.file = file;
      this.id = null;
      this.type = null;
      this.length = 0;
    }

    Resource.prototype.parse = function() {
      var nameLength;
      this.type = this.file.readString(4);
      this.id = this.file.readShort();
      nameLength = Util.pad2(this.file.readByte() + 1) - 1;
      this.name = this.file.readString(nameLength);
      return this.length = Util.pad2(this.file.readInt());
    };

    return Resource;

  })();

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/resource.js
// module id = 90
// module chunks = 0